import { ThemeProvider } from "@mui/material/styles"
import ScormProvider from "react-scorm-provider"
import { MainProvider } from "./contexts/MainContext"
import { DialogsModule } from "./modules/dialogs/DialogsModule"
import EventsModule from "./modules/events/EventsModule"
import { GamesModule } from "./modules/games/GamesModule"
import { MapModule } from "./modules/map/MapModule"
import { PopUpsModule } from "./modules/popups/PopUpsModule"
import { UIModule } from "./modules/ui/UIModule"
import { finalTheme } from "./style/theme"

function App() {
  return (
    <ScormProvider
      debug={true}
    >
      <ThemeProvider theme={finalTheme}>
        <MainProvider>
          <MapModule />
          <GamesModule />
          <DialogsModule />
          <PopUpsModule />
          <UIModule />
          <EventsModule />
        </MainProvider>
      </ThemeProvider>
    </ScormProvider>
  )
}

export default App
